import gql from "graphql-tag";

import { productFields, fragmentName } from "./fragments/productFields";

export const getProducts = gql`
  ${productFields}
  query Products($businessUnit: String!, $filters: [String], $count: Int, $page: Int) {
    productList(businessUnit: $businessUnit, filters: $filters, count: $count, page: $page) {
      totalResults
      products {
        ...${fragmentName}
      }
      filters {
        code
        slug
        count
        __typename @skip(if: true)
      }
    }
  }
`;
